export const uniq = (array: string[]): string[] => {
  return array.filter((el, index, arr) => index == arr.indexOf(el));
};
